import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b59bd698"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "12",
  cy: "12",
  r: "10"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("line", {
  x1: "8",
  y1: "12",
  x2: "16",
  y2: "12"
}, null, -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "EQUIPMENT", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "12",
  cy: "12",
  r: "10"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("line", {
  x1: "12",
  y1: "8",
  x2: "12",
  y2: "16"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("line", {
  x1: "8",
  y1: "12",
  x2: "16",
  y2: "12"
}, null, -1))
const _hoisted_10 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "columns" }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = { class: "col" }
const _hoisted_14 = { class: "credits" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "credits" }, "Credits", -1))
const _hoisted_16 = ["value", "disabled"]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "BROKEN!", -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { class: "item-description" }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { key: 3 }
const _hoisted_23 = { class: "pick-up-item-modal-expander" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = { class: "storage-modal-expander" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "new-item-modal-expander" }
const _hoisted_28 = { class: "modal-expander" }
const _hoisted_29 = { class: "custom-modal-expander" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { for: "uses-number" }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "armor-number" }, " Armor ", -1))
const _hoisted_34 = ["disabled"]
const _hoisted_35 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EquipmentButton = _resolveComponent("EquipmentButton")!
  const _component_Wearing = _resolveComponent("Wearing")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_DropDown = _resolveComponent("DropDown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_Transition, null, {
        default: _withCtx(() => [
          (_ctx.displayCapacityMinus())
            ? (_openBlock(), _createElementBlock("svg", {
                key: 0,
                class: "capacity-btn minus button",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickCapacityMinus && _ctx.clickCapacityMinus(...args))),
                xmlns: "http://www.w3.org/2000/svg",
                width: "16",
                height: "16",
                viewBox: "0 0 24 24",
                "stroke-width": "3",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, _hoisted_5))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _hoisted_6,
      _createVNode(_Transition, null, {
        default: _withCtx(() => [
          (_ctx.displayCapacityPlus())
            ? (_openBlock(), _createElementBlock("svg", {
                key: 0,
                class: "capacity-btn plus button",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickCapacityPlus && _ctx.clickCapacityPlus(...args))),
                xmlns: "http://www.w3.org/2000/svg",
                width: "16",
                height: "16",
                viewBox: "0 0 24 24",
                "stroke-width": "3",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, _hoisted_10))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["container", _ctx.editMode ? 'edit-mode' : ''])
    }, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Math.ceil((_ctx.carryCapacity + 1) / 2) - 1, (n) => {
            return (_openBlock(), _createBlock(_component_EquipmentButton, {
              index: n-1,
              key: n,
              onItemModal: ($event: any) => (_ctx.openItemModal(n-1)),
              onDropModal: ($event: any) => (_ctx.openDropModal(n-1)),
              onEmptyModal: ($event: any) => (_ctx.openEmptyModal(n-1))
            }, null, 8, ["index", "onItemModal", "onDropModal", "onEmptyModal"]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_13, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Math.floor((_ctx.carryCapacity + 1) / 2), (n) => {
            return (_openBlock(), _createBlock(_component_EquipmentButton, {
              onItemModal: ($event: any) => (_ctx.openItemModal(_ctx.index2(n))),
              onDropModal: ($event: any) => (_ctx.openDropModal(_ctx.index2(n))),
              onEmptyModal: ($event: any) => (_ctx.openEmptyModal(_ctx.index2(n))),
              index: _ctx.index2(n),
              key: n
            }, null, 8, ["onItemModal", "onDropModal", "onEmptyModal", "index"]))
          }), 128))
        ])
      ]),
      _createVNode(_component_Wearing, {
        "suppress-modals": _ctx.anyModalOpen,
        onModalOpen: _ctx.wearingModalChange
      }, null, 8, ["suppress-modals", "onModalOpen"]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("input", {
          id: "credits",
          type: "number",
          value: _ctx.credits,
          onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.updateCredits && _ctx.updateCredits(...args))),
          disabled: _ctx.editMode
        }, null, 40, _hoisted_16)
      ])
    ], 2),
    _createVNode(_component_Modal, {
      visible: !_ctx.editMode && _ctx.itemModalOpen,
      title: _ctx.equipped[_ctx.selectedItemIndex]?.name,
      onClose: _ctx.closeAllModals
    }, {
      default: _withCtx(() => [
        (_ctx.equipped[_ctx.selectedItemIndex]?.broken)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.equipped[_ctx.selectedItemIndex]?.description), 1),
        (_ctx.equipped[_ctx.selectedItemIndex]?.type === _ctx.EquipmentTypes.ARMOR)
          ? (_openBlock(), _createElementBlock("p", _hoisted_21, " Armor: " + _toDisplayString(_ctx.equipped[_ctx.selectedItemIndex]?.armor), 1))
          : _createCommentVNode("", true),
        (_ctx.equipped[_ctx.selectedItemIndex]?.broken)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              class: "modal-btn green",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.repairArmor(_ctx.selectedItemIndex)))
            }, " Repair "))
          : _createCommentVNode("", true),
        (_ctx.equipped[_ctx.selectedItemIndex]?.type === _ctx.EquipmentTypes.GUN)
          ? (_openBlock(), _createElementBlock("p", _hoisted_22, " Capacity: " + _toDisplayString(_ctx.equipped[_ctx.selectedItemIndex]?.maxUses) + " Shots ", 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible", "title", "onClose"]),
    _createVNode(_component_Modal, {
      visible: !_ctx.editMode && _ctx.dropModalOpen,
      title: _ctx.equipped[_ctx.selectedItemIndex]?.name,
      color: "lightgreen",
      onClose: _ctx.closeAllModals
    }, {
      default: _withCtx(() => [
        _createElementVNode("button", {
          class: "modal-btn red",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.dropItem && _ctx.dropItem(...args)))
        }, " Drop "),
        _createElementVNode("button", {
          class: "modal-btn green",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.storeItem && _ctx.storeItem(...args)))
        }, " Store ")
      ]),
      _: 1
    }, 8, ["visible", "title", "onClose"]),
    _createVNode(_component_Modal, {
      visible: !_ctx.editMode && _ctx.emptyModalOpen,
      title: 'Pick Up Item',
      color: "lightgreen",
      onClose: _ctx.closeAllModals
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("button", {
            class: "modal-btn green",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.openNewItemModal && _ctx.openNewItemModal(...args)))
          }, " New Item "),
          _createElementVNode("button", {
            class: "modal-btn green",
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.openStorageModal && _ctx.openStorageModal(...args))),
            disabled: _ctx.locker.length === 0
          }, " From Storage ", 8, _hoisted_24)
        ])
      ]),
      _: 1
    }, 8, ["visible", "onClose"]),
    _createVNode(_component_Modal, {
      visible: !_ctx.editMode && _ctx.storageModalOpen,
      title: 'Storage Locker',
      color: "lightgreen",
      onClose: _ctx.closeStorageModal
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_25, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locker, (item, index) => {
            return (_openBlock(), _createElementBlock("button", {
              class: _normalizeClass(["modal-btn green", {strike: item.broken}]),
              onClick: ($event: any) => (_ctx.pickUpItemFromStorage(index))
            }, _toDisplayString(item.name) + _toDisplayString(item.uses >= 0 ? ` (${item.uses})` : ''), 11, _hoisted_26))
          }), 256))
        ])
      ]),
      _: 1
    }, 8, ["visible", "onClose"]),
    _createVNode(_component_Modal, {
      visible: !_ctx.editMode && _ctx.newItemModalOpen,
      title: 'New Item',
      color: "lightgreen",
      onClose: _ctx.closeNewItemModal
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("button", {
            class: "modal-btn green",
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.openStandardItemModal && _ctx.openStandardItemModal(...args)))
          }, " Standard "),
          _createElementVNode("button", {
            class: "modal-btn green",
            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.openCustomItemModal && _ctx.openCustomItemModal(...args)))
          }, " Custom ")
        ])
      ]),
      _: 1
    }, 8, ["visible", "onClose"]),
    _createVNode(_component_Modal, {
      visible: !_ctx.editMode && _ctx.standardItemModalOpen,
      title: 'Standard Item',
      color: "lightgreen",
      onClose: _ctx.closeStandardItemModal
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("button", {
            class: "modal-btn green",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.openItemSelectModal('Weapons')))
          }, " Weapon "),
          _createElementVNode("button", {
            class: "modal-btn green",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.openItemSelectModal('Armor')))
          }, " Armor "),
          _createElementVNode("button", {
            class: "modal-btn green",
            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.openItemSelectModal('Other')))
          }, " Other ")
        ])
      ]),
      _: 1
    }, 8, ["visible", "onClose"]),
    _createVNode(_component_Modal, {
      visible: !_ctx.editMode && _ctx.customItemModalOpen,
      title: 'Custom Item',
      color: "lightgreen",
      onClose: _ctx.closeCustomItemModal
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_29, [
          _createVNode(_component_DropDown, {
            label: "Custom Item Type",
            "hide-label": true,
            options: ['Basic','Gun','Armor','Consumable'],
            color: "lightgreen",
            onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.changeCustomItemType($event)))
          }),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.customItem.name) = $event)),
            placeholder: "Name"
          }, null, 512), [
            [_vModelText, _ctx.customItem.name]
          ]),
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.customItem.description) = $event)),
            placeholder: "Description",
            class: "description-input"
          }, null, 512), [
            [_vModelText, _ctx.customItem.description]
          ]),
          (_ctx.customItem.type === _ctx.EquipmentTypes.GUN ||
                _ctx.customItem.type === _ctx.EquipmentTypes.USES)
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.customItem.type === _ctx.EquipmentTypes.GUN ? 'Shots' : 'Uses'), 1),
                _withDirectives(_createElementVNode("input", {
                  id: "uses-number",
                  class: "uses-input",
                  type: "number",
                  onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.validateMaxUses($event))),
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.customItem.maxUses) = $event))
                }, null, 544), [
                  [_vModelText, _ctx.customItem.maxUses]
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.customItem.type === _ctx.EquipmentTypes.ARMOR)
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _hoisted_33,
                _withDirectives(_createElementVNode("input", {
                  id: "armor-number",
                  class: "uses-input",
                  type: "number",
                  onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.validateArmor($event))),
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.customItem.armor) = $event))
                }, null, 544), [
                  [_vModelText, _ctx.customItem.armor]
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "modal-btn green",
            onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.pickUpItem(_ctx.customItem))),
            disabled: !_ctx.customItem.name
          }, " Acquire ", 8, _hoisted_34)
        ])
      ]),
      _: 1
    }, 8, ["visible", "onClose"]),
    _createVNode(_component_Modal, {
      visible: !_ctx.editMode && _ctx.itemSelectModalOpen,
      title: _ctx.itemSelectModalTitle,
      color: "lightgreen",
      onClose: _ctx.closeItemSelectModal
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectItems, (item) => {
          return (_openBlock(), _createElementBlock("div", null, [
            _createElementVNode("button", {
              class: "modal-btn green",
              onClick: ($event: any) => (_ctx.pickUpItem(item))
            }, _toDisplayString(item.name), 9, _hoisted_35)
          ]))
        }), 256))
      ]),
      _: 1
    }, 8, ["visible", "title", "onClose"])
  ]))
}